import api from '../api'

export default {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        setRankingAwardList(state, info) {
            state.list = info
        }
    },
    getters: {
        getRankingAward(state) {
            return state.list;
        }
    },
    actions: {
        getRankingAwardList(store) {
            return api.post(`/rankingAward/list`, '指定对应的排名奖励')
        },
        addRankingAward(store, {...params}) {
            return api.post(`/rankingAward/add/`, '新增排名奖励', params)
        },
        updateRankingAward(store, params) {
            return api.post(`/rankingAward/update/`, '修改排名奖励', params)
        },
        deleteRankingAward(store, id) {
            return api.post(`/rankingAward/del/${id}`, '删除排名奖励')
        },

    }
}